/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from "../actions/types";
// import { ROLES } from '../config';

const INITIAL_STATE = {
  singleCompanyFiles: [],
  multipleCompanyFiles: [],
  files: [],
  uploadType: "project",
};

export default function filesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.GET_SINGLE_COMPANY_FILES:
      return { ...state, singleCompanyFiles: action.payload };
    case types.GET_MULTIPLE_COMPANY_FILES:
      return { ...state, multipleCompanyFiles: action.payload };
    case types.SET_FILES:
      return { ...state, files: action.payload };
    case types.SET_FILES_TERMS:
      return { ...state, filesAndTerms: action.payload };
    case types.SET_FILES_FOR_DOWNLOAD:
      return { ...state, filesForDownload: action.payload };
    case types.SET_UPLOAD_TYPE:
      return { ...state, uploadType: action.payload };
    default:
      return state;
  }
}

// Selectors
export const getSingleCompanyFilesReducer = (state) => {
  return state.files.singleCompanyFiles;
};
export const getMultipleCompanyFilesReducer = (state) => {
  return state.files.multipleCompanyFiles;
};
export const getAllFiles = (state) => {
  return state.files.files;
};
export const getFilesAndTerms = (state) => {
  return state.files.filesAndTerms;
};
export const getFilesForDownload = (state) => {
  return state.files.filesForDownload;
};
export const getUploadType = (state) => {
  return state.files.uploadType;
};
